import { logger } from '@/services/logger/loggers'
import { auth } from '@/modules/auth'
import { anonymizeTracking } from '@/services/tracking'
import { featureFlag } from '@/services/featureFlagProvider'

export type BaseLogoutOptions = {
  callBackend?: boolean
}

export const logout = async () => {
  try {
    await auth.value?.logout()
  } catch (error) {
    logger.error('[tms-shell] Error during logout', { error })
  } finally {
    logger.unsetUserData()
    anonymizeTracking()
    await featureFlag.anonymize()
    window.location.reload()
  }
}
